import Embed from 'bcube-cms/src/components/texteditor/advanced/blots/embed.js';

class DailymotionEmbed extends Embed {
  static create(value) {
    const domNode = super.create({
      ...value,
      label: 'dailymotion',
      buttons: ['edit'],
    });

    domNode.insertAdjacentHTML('beforeend', this.html(value));

    return domNode;
  }

  static html({ videoId }) {
    const url = `//www.dailymotion.com/embed/video/${videoId}`;
    return `
    <div class="ql-dailymotion-iframe">
      <div>
        <iframe width="640" height="360" src="${url}" data-src="${url}" data-video-type="dailymotion" frameborder="0" allowfullscreen>
      </div>
    </div>
    `;
  }

  static value(domNode) {
    return {
      videoId: domNode.dataset.embedVideoId,
    };
  }
}

DailymotionEmbed.blotName = 'dailymotionEmbed';
DailymotionEmbed.className = 'ql-dailymotion';
DailymotionEmbed.tagName = 'div';

export { DailymotionEmbed as default };
